import { useState } from "react";
import { Drawer, message } from "antd"
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import PasswordIcon from '../../../assets/password.svg';
import PasswordHide from '../../../assets/password-hide.svg';
import PasswordShow from '../../../assets/password-show.svg';
import { changePasswordValidation } from "../../../utils/validations/formValidations";
import { getFromLocalStorage, setInLocalStorage } from "../../../utils/storageUtil";
import { ChangePass } from "../../../utils/api";

const ChangePassword = ({ openChangePass, setOpenChangePass }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [oldPasswordVisible, setOldPasswordVisible] = useState(false);
    const [passwordOneVisible, setIsPasswordOneVisible] = useState(false);
    const [passwordTwoVisible, setIsPasswordTwoVisible] = useState(false);

    const { register, handleSubmit, formState: { errors, isValid, isDirty }, reset } = useForm({ resolver: yupResolver(changePasswordValidation) });

    const onSubmit = async data => {
        if (!isDirty && !isValid) {
            return;
        }
        try {
            setIsLoading(true);
            const formData = {
                password: data.oldPassword,
                newPassword: data.newPassword,
            };
            const response = await ChangePass(formData, getFromLocalStorage('admin')?.id);
            if (response?.isSuccess) {
                message.success('Password changed Successfully');
                setIsLoading(false);
                handleClose();
            } else {
                message.error(response?.error);
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
        }
    }

    const handleClose = () => {
        setOpenChangePass(false);
        reset();
    }

    return (
        <>
            <Drawer title="Change Password" placement="right" onClose={handleClose} open={openChangePass}>
                <div className='w-full poppins'>
                    <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)} noValidate>
                        <div className="border border-input-placeholder flex gap-x-2 rounded-lg p-3 relative mt-4">
                            <label className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1" htmlFor="oldPassword">Old Password</label>
                            <img src={PasswordIcon} alt="password-svg" width={12} />
                            <input className="w-full outline-none text-[12px] text-input-placeholder" type={oldPasswordVisible ? "text" : "password"} id="oldPassword" {...register('oldPassword')} />
                            <img src={oldPasswordVisible ? PasswordHide : PasswordShow} alt="password-hide" width={12} className="cursor-pointer" onClick={() => setOldPasswordVisible(!oldPasswordVisible)} />
                        </div>
                        <p className="text-[red] text-[12px]">{errors.oldPassword?.message}</p>
                        <div className="border border-input-placeholder flex gap-x-2 rounded-lg p-3 relative mt-4">
                            <label className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1" htmlFor="newPassword">New Password</label>
                            <img src={PasswordIcon} alt="password-svg" width={12} />
                            <input className="w-full outline-none text-[12px] text-input-placeholder" type={passwordOneVisible ? "text" : "password"} id="newPassword" {...register('newPassword')} />
                            <img src={passwordOneVisible ? PasswordHide : PasswordShow} alt="password-hide" width={12} className="cursor-pointer" onClick={() => setIsPasswordOneVisible(!passwordOneVisible)} />
                        </div>
                        <p className="text-[red] text-[12px]">{errors.newPassword?.message}</p>
                        <div className="border border-input-placeholder flex gap-x-2 rounded-lg p-3 relative mt-4">
                            <label className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1" htmlFor="confirmPassword">Confirm Password</label>
                            <img src={PasswordIcon} alt="password-svg" width={12} />
                            <input className="w-full outline-none text-[12px] text-input-placeholder" type={passwordTwoVisible ? "text" : "password"} id="confirmPassword" {...register('confirmPassword')} />
                            <img src={passwordTwoVisible ? PasswordHide : PasswordShow} alt="password-hide" width={12} className="cursor-pointer" onClick={() => setIsPasswordTwoVisible(!passwordTwoVisible)} />
                        </div>
                        <p className="text-[red] text-[12px]">{errors.confirmPassword?.message}</p>

                        <div className="mt-6 flex items-center justify-center gap-x-3">
                            <button type='reset' className=" bg-white text-primary-700 border border-primary-700 text-[10px] px-12 py-3 rounded-lg" onClick={handleClose}>Back</button>
                            <button
                                type="submit"
                                className="bg-primary-700 border border-primary-700 text-white text-[10px] px-4 py-3 rounded-lg flex items-center gap-x-2"
                                disabled={isLoading}
                            >
                                Change Password
                                {isLoading && <span className="loader"></span>}
                            </button>
                        </div>

                    </form>
                </div>
            </Drawer>
        </>
    )
}

export default ChangePassword;